/* eslint-disable no-plusplus */
import React from 'react';

// Dependencies
import { AccessManagementPermissionsService } from 'services/accessManagementPermissions';
import { get, size, cloneDeep, isEmpty, find, isEqual } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

// View
import { accessManagementPermissionsView as AccessManagementPermissionsView } from 'ui/views/accessManagementPermissionsView';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { SIZES } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { AccessManagementPermissions } from 'ui/containers/AccessManagementPermissions';
 *
 * // render
 * <AccessManagementPermissions propName='propValue'/>
 */
export class AccessManagementPermissions extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.__bind();

        this.data = {};

        this.state = {
            isFetching: true,
            componentData: {},
            isEditMode: false,
            items: [],
            initialItems: [],
            isSubmitting: false
        };

       this.AccessManagementPermissionsService = new AccessManagementPermissionsService();

       // start data fetch
       this.fetchComponentData( props );

    }

    __bind() {
        log.debug( 'AccessManagementPermissions.__bind()' );
        this.toggleEditMode = this.toggleEditMode.bind( this );
        this.getSliderMapBasedOnIndex = this.getSliderMapBasedOnIndex.bind( this );
        this.handlePermissionChange = this.handlePermissionChange.bind( this );
        this.handlePermissionsUpdate = this.handlePermissionsUpdate.bind( this );
        this.submitPermissionsUpdate = this.submitPermissionsUpdate.bind( this );
    }

    async fetchComponentData( props ) {
        log.debug( 'AccessManagementPermissions.fetchComponentData()' );

        // cancel ongoing request
        this.AccessManagementPermissionsService.cancel();

        // fetch component data
        const { status, data } = await this.AccessManagementPermissionsService.fetchComponentData( {
            url: get( props, 'widget.url', '' ),
            data: {}
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {

            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
                items: get( data, 'state.items', [] ),
                initialItems: get( data, 'state.items', [] ),
                sliderBreakDownVar: get( data, 'state.sliderBreakDownVar', 3 ),
                isEditMode: false
            } );
        }

    }

    toggleEditMode() {
        log.debug( 'AccessManagementPermissions.toggleEditMode()' );

        this.setState( { isEditMode: !this.state.isEditMode, items: this.state.initialItems } );
    }

    getSliderMapBasedOnIndex( index ) {
        log.debug( 'AccessManagementPermissions.getSliderMapBasedOnIndex()' );

        const _mapArray = [];

        const items = cloneDeep( get( this.state, 'componentData.options.roleOptions', [] ) );

        for ( let i = index; i < size( items ); i++ ) {

            if ( this.state.sliderBreakDownVar === _mapArray.length ) {
                break;
            }

            const value = get( items[ i ], 'id', undefined );
            _mapArray.push( value );

        }
        
        this.setState( {
            ...this.state,
            updatedSliderMap: _mapArray
        } );
    }

    handlePermissionChange( { value, role, permission } = {} ) {
        log.debug( 'AccessManagementPermissions.handlePermissionChange()' );

        if( !this.state.isEditMode ) { // if not in Edit mode do nothing
            return null;
        }

        const items = cloneDeep( this.state.items );

        const changedInRole = find( items, { roleId: role } );

        if( !isEmpty( changedInRole ) ) {

            // if( value ) {

                const changedPermission = find( changedInRole.permissions, { value: permission } );

                changedPermission.checked = value;


            //     const permissionResource = find( resourcesOptions, { value: permission } );
            //     changedInRole.permissions = union( [ { id: get( permissionResource, 'id' ), value: permissionResource.value } ], changedInRole.permissions );
            // } else {

            //     changedInRole.permissions = filter( changedInRole.permissions, ( _permission ) => { return _permission.value !== permission; } );
            // }

            this.setState( {
                items: items
            } );
        }

    }

    async submitPermissionsUpdate( { url } = {} ) {
        log.debug( 'AccessManagementPermissions.handlePermissionsUpdate()' );

        // fetch component data
        const { status, data } = await this.AccessManagementPermissionsService.submitPermissionsUpdate( {
            url: url,
            data: this.state.items
        } );


        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {

            if( !isEmpty( data ) ) {
                errorOverlay.open( {  size: SIZES.SMALL, message: data.description } );
            } else {
                errorOverlay.open();
            }
        } else {

            // show success overlay
            successOverlay.open( {
                message: get( data, 'description', '' ),
                config: {
                    autoClose: false
                }
            } );

            this.fetchComponentData( this.props );
        }

        this.setState( {
            isSubmitting: false,  // remove submit button loading
            isFetching: true // start page preloader
        } );
        
    }

    handlePermissionsUpdate( payload ) {
        log.debug( 'AccessManagementPermissions.handlePermissionsUpdate()' );

        this.setState( {
            isSubmitting: true // add submit button loading
        }, () => this.submitPermissionsUpdate( payload ) );
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <AccessManagementPermissionsView
                { ...this.state }
                toggleEditMode = { this.toggleEditMode }
                getSliderMapBasedOnIndex = { this.getSliderMapBasedOnIndex }
                handlePermissionChange= { this.handlePermissionChange }
                handlePermissionsUpdate = { this.handlePermissionsUpdate }
                disableSubmit = { isEqual( this.state.initialItems, this.state.items ) }
            />
        );
    }
}

// set display name
AccessManagementPermissions.displayName = 'AccessManagementPermissions';

// set default props
AccessManagementPermissions.defaultProps = {};

// prop types
AccessManagementPermissions.propTypes = {};
